import { render, staticRenderFns } from "./GiacenzeMagazzino.vue?vue&type=template&id=be109e60&"
import script from "./GiacenzeMagazzino.vue?vue&type=script&lang=js&"
export * from "./GiacenzeMagazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports